export const LinkToHomePage = "#home";
export const LinkToContactPage = "#contact";
export const LinkToMusicPage = "#music";
export const LinkToMusicLivePage = "#music/live";
export const LinkToMusicCoversPage = "#music/covers";
export const LinkToMusicOriginalsPage = "#music/originals";
export const LinkToTipJarPage = "#tipjar";
export const LinkToEduPage = "#resources";
export const LinkToEduIntervalNotesQuizPage = "#resources/intervalnotesquiz";
